<template>
  <base-view
      @click:add="criar"
      :permiteCadastrar="permiteCadastrar"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">

    <CreateEditContatoDialog :item="item" v-model="editDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>
    <ContatoAlteraSenhaAdm :item="item" v-model="alteraSenhaAdmOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>

    <div>
      <ContatoDataTable ref="dataTable"
                             @click:edit="editar"
                             @click:aletarSenha="aletarSenha"
                             @click:remove="remover"
                         :search-values="searchValues"/>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        color="primary"
        class="ma-4"
      ></v-progress-circular>
    </v-overlay>    
  </base-view>

</template>

<script>
import ContatoDataTable from "../../components/shared/datatables/ContatoDataTable";
import BaseView from "../BaseView";
import {findOne, remove} from "../../api/contato";
import {findAll as findAllComprador} from '../../api/comprador';
import {findAll as findAllFornecedor} from '../../api/fornecedor';
import CreateEditContatoDialog from "../../components/shared/dialogs/CreateEditContatoDialog";
import ContatoAlteraSenhaAdm from "@/views/AlterarSenha/ContatoAlteraSenhaAdm"
import {mapGetters} from "vuex";

export default {
  name: "index",
  components: {CreateEditContatoDialog, BaseView, ContatoDataTable, ContatoAlteraSenhaAdm},
  data() {
    return {
      item: null,
      loading: false,
      editDialogOpened: false,
      alteraSenhaAdmOpened: false,
      permiteCadastrar: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [
        {
          name: 'Nome',
          column: 'nome',
          type: 'text'
        },
        {
          name: 'Tipo Empresa',
          column: 'tipoEmpresa',
          type: 'autocomplete',
          optionsFactory: () => ([
            { key: 'FOR', valor: 'Fornecedor' },
            { key: 'COM', valor: 'Comprador' },
          ])
        },         
        {
          name: 'Comprador',
          column: 'idComprador',
          type: 'autocomplete',
          optionsFactory: (search) => findAllComprador(1, {
            nome: search,
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.nomeCompleto
                }))
              })

        }, 
        {
          name: 'Fornecedor',
          column: 'idFornecedor',
          type: 'autocomplete',
          optionsFactory: (search) => findAllFornecedor(1, {
            nome: search,
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.nomeCompleto
                }))
              })

        },       
      ]
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
  },  
  methods: {
    updateSearch(search) {
      this.searchValues = search;
    },
    criar() {
      this.item = {
        descricao: "",
        status: "A"
      };
      this.editDialogOpened = true;
    },
    async editar(objeto) {
      try {
        this.loading = true;
        const retorno = await findOne(objeto.id);
        this.item = retorno.dados[0];
        this.editDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados do Responsável. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    }, 
    async aletarSenha(objeto) {
      this.item = objeto;
      this.alteraSenhaAdmOpened = true;
    }, 
    async remover({id}) {
      try {
        this.loading = true;
        await remove(id);
        this.$toast.success(`Responsável removido com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        this.$toast.error(`Não foi possível remover o Responsável.`, {
          timeout: 6000
        })
      } finally {
        this.loading = false;
      }
    },
	  async getPermissoes(){
      this.getPermissaoPorItemPerfil("Contato.cadastro",this.nivelUsuarioLogado)
        .then(permissao => {
          this.permiteCadastrar = permissao;
        });
    },
  },
  mounted() {
    this.getPermissoes();
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>